module.exports = __webpack_public_path__ + "static/img/3.404ed4d.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/VascularSystem/Meeting809/images/3.png
// module id = b5sA
// module chunks = 4